import { newApiFetchV2 } from "./utils";

type IDiagnosticToken = {
  url: string;
  dash_auth_token: string;
};

export const getUserGroupDiagnosticToken = (): Promise<IDiagnosticToken> => newApiFetchV2("/diagnostic_funnel_api/generate_token", {});
